import { render, staticRenderFns } from "./DepositInfoBox.vue?vue&type=template&id=d8163674"
import script from "./DepositInfoBox.vue?vue&type=script&lang=js"
export * from "./DepositInfoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports